<div class="table-container">

    <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-xxs" fxLayoutGap="2%">
        <div *ngIf="tableTitle">
            <p class="upper bold-font" style="font-size: 20px; min-width: 230px;">{{ tableTitle }}:</p>
        </div>
        <div class="search-wrapper" fxLayout="row" fxLayoutAlign="center center">
            <input #filter placeholder="Wpisz szukaną frazę" class="search-bar" [formControl]="filterControl"
                (keyup.enter)="filterByTrigger()">
            <mat-icon class="text-primary" (click)="clearFilter()">close</mat-icon>
            <mat-icon class="text-primary" (click)="filterByTrigger()">search</mat-icon>
        </div>
        <div *ngIf="hasAddButton">
            <button class="upper button-primary" style="min-width: 150px;" routerLink="add">nowy koszyk</button>
        </div>
    </div>

    <div class="table-wrapper inner-table-wrapper">
        <inner-loader [isActive]="isLoadingResults"></inner-loader>
        <mat-table #table [dataSource]="data" class="mat-cell inner-table" [style.height]="screenHeight"
            [class.competitor-table]="isComp">

            <ng-container *ngFor="let column of columnsData" [matColumnDef]="column.columnDef">
                <mat-header-cell *matHeaderCellDef [fxFlex]="column.width">
                    <pr-drop-select [placeholder]="column.header" class="cell-header-wrapper" fxLayout="row"
                        fxLayoutAlign="space-between center" fxFlexFill [optLabel]="column.header"
                        [selectName]="selectSortName(column)" (change)="sortChange($event)"
                        [isSelected]="checkIfSelected(column.columnDef)" [filterDef]="column.filterValue"
                        (filterChanged)="selFilterChanged($event)"></pr-drop-select>
                </mat-header-cell>
                <mat-cell *matCellDef="let row" [matTooltip]="getTooltip(column, row[column.columnDef])"
                    [fxFlex]="column.width">
                    <div *ngIf="column.type && column.type === 'date'">
                        {{ generalService.parseDate(row[column.columnDef]) || '-' }}
                    </div>
                    <div *ngIf="column.type && column.type === 'vat'" class="percentage-suf">
                        {{ generalService.parseVAT(row[column.columnDef]) | number:'.0-0' }}
                    </div>
                    <div *ngIf="!column.suffix && !column.type">
                        {{ row[column.columnDef] || "-" }}
                    </div>
                    <div *ngIf="column.type && column.type === 'number'">
                        {{ row[column.columnDef] || "-" }}
                    </div>
                    <div *ngIf="column.type && column.type === 'margin'" class="percentage-suf">
                        {{ generalService.parseVAT(row[column.columnDef]) | number:'.1-1' }}
                    </div>
                    <div *ngIf="!column.type && column.suffix && column.suffix === 'percentage'" class="percentage-suf">
                        {{ row[column.columnDef] }}
                    </div>
                    <div *ngIf="column.suffix && column.suffix === 'currency'" class="currency-suf">
                        {{ row[column.columnDef] | number:'.2-2' }}
                    </div>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="notImplemented(row)">
            </mat-row>

        </mat-table>

        <mat-toolbar>
            <mat-toolbar-row>
                <!-- here select button -->
                <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 25, 50, 100]" [length]="itemsLength"
                    (page)="pageEvent = getPaginatorData($event)"></mat-paginator>
            </mat-toolbar-row>
        </mat-toolbar>

    </div>

</div>